import { Illus } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { getCurrentPolicyVersion, PolicyAdjustmentResponse } from '../../../../../domain'
import {
  TKey,
  useWriskTranslation,
} from '../../../../../infrastructure/internationalisation'
import { isISOToday, toFormattedDateWithDay } from '../../../../../util/date'
import { usePrincipal } from '../../../../authentication'
import { Feedback } from '../../../../organisms/feedback/Feedback'
import { ActionBar } from '../../../../organisms/form'
import { FullPage } from '../../../../templates'
import { usePolicy } from '../../PolicyProvider'

const tKey = TKey('pages.adjustment-success')

interface AdjustmentSuccessPageProps {
  policyAdjustmentResponse: PolicyAdjustmentResponse
  onComplete: () => void
  onRepeat: () => void
}

export const AdjustmentSuccessPage: FunctionComponent<AdjustmentSuccessPageProps> = ({
  policyAdjustmentResponse,
  onComplete,
  onRepeat,
}) => {
  const { t } = useWriskTranslation()
  const { isAdmin } = usePrincipal()
  const {
    policy: { policyId },
  } = usePolicy()

  const policyVersion = getCurrentPolicyVersion(
    policyAdjustmentResponse.updatedPolicyVersions,
  )

  const startedAt = policyVersion.startedAt
  const subheaderPath =
    startedAt && !isISOToday(policyVersion.startedAt) ? 'deferred' : 'immediately'
  const subheader = t(tKey('subheader', subheaderPath), {
    effectiveAt: toFormattedDateWithDay(startedAt ?? ''),
  })

  return (
    <FullPage
      pageId='adjustment-success-page'
      header={t(tKey('header'))}
      subheader={subheader}
      upperHeader={<Illus alt='Success' illus='bindSuccess' />}
    >
      <ActionBar
        onConfirm={onComplete}
        onDismiss={onRepeat}
        loading={false}
        tKey={tKey}
      />
      {!isAdmin && <Feedback type='mta' tags={{ policyId }} />}
    </FullPage>
  )
}
